import { Component, ElementRef, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { gsap, Expo, Quad } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { BackgroundVideoService } from 'src/app/services/BackgroundVideo/background-video.service';
import { PageDataService } from 'src/app/services/page-data.service';

@Component({
    selector: 'app-home-slider',
    templateUrl: './home-slider.component.html',
    styleUrls: ['./home-slider.component.scss']
})
export class HomeSliderComponent implements OnInit {
    @Input() data: any = {}
    @Input() isMobile: boolean
    selected: number = 0
    timeoutIndex: any

    @ViewChildren("videoEl") videoEl: QueryList<ElementRef>;
    @ViewChild("slides") slides: ElementRef

    constructor(
        private pageDataService: PageDataService,
        public bgVideoService: BackgroundVideoService
    ) {
        gsap.registerPlugin(ScrollToPlugin);

        this.pageDataService.isOverlayOpen$.subscribe((value) => {
            if (value) {
                this.onBlur()
            }
            else {
                this.onFocus()
            }
        })

        this.bgVideoService.isPlaying$.subscribe(isPlaying => {
            if (isPlaying) {
                this.onFocus()
            }
            else {
                this.onBlur()
            }
        });
    }

    ngOnInit(): void {
        setTimeout(() => {
            gsap.to('.HomeSlider .slides .slide:nth-child(1) .contentWrapper', 0.8, { x: 0, opacity: 1, ease: Quad.easeOut });
        }, 500);

        setTimeout(() => {
            gsap.set(this.slides.nativeElement, { width: (100 * this.data.slides.length) + '%' })
        }, 100);

        // if (this.isMobile || this.data.slides[0].video == '') {
        //     this.loop();
        // }
    }

    ngOnDestroy(): void {
        clearTimeout(this.timeoutIndex);
    }

    ngAfterViewInit(): void {
        if (!this.isMobile && this.data.slides[0].video != '' || this.isMobile && this.data.slides[0].videoMob != '') {
            let videos = this.videoEl.toArray()
            videos.map((video, i) => {
                video.nativeElement.muted = true
                video.nativeElement.play()
                if (i != 0) {
                    video.nativeElement.pause()
                }
            })
        }
    }


    onSelect(i: number) {
        let speed0 = !this.isMobile ? 0.8 : 0.4
        let speed1 = !this.isMobile ? 0.6 : 0.3
        let speed2 = !this.isMobile ? 1 : 0.5

        if (i != this.selected) {
            clearTimeout(this.timeoutIndex);

            let dir = -1;
            if (!this.isMobile && this.data.slides[0].video != '' || this.isMobile && this.data.slides[0].videoMob != '') {
                try {

                    this.videoEl.toArray()[this.selected].nativeElement.pause()
                    this.videoEl.toArray()[this.selected].nativeElement.currentTime = 0;
                }
                catch (e) { }
                try {
                    if (this.data.slides[i].video != '') {
                        this.videoEl.toArray()[i].nativeElement.play()
                        this.bgVideoService.setPlay()
                    }
                }
                catch (e) { }
            }

            if (this.data.slides[i].video == '') {

                this.timeoutIndex = setTimeout(() => {
                    this.next()
                }, 6000);
            }

            gsap.to('.HomeSlider .slides', speed0, { x: -i * (100 / this.data.slides.length) + '%', ease: Quad.easeOut });

            if (this.selected < i) {

                gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (this.selected + 1) + ') .contentWrapper', speed1, { opacity: '1' }, { opacity: '0', ease: Quad.easeOut });
                // move new selected in
                gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (i + 1) + ') .contentWrapper', speed2, { x: '20vw', opacity: 0 }, { x: 0, opacity: 1, ease: Quad.easeOut });
            }
            else {
                gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (this.selected + 1) + ') .contentWrapper', speed1, { opacity: '1' }, { opacity: '0', ease: Quad.easeOut });
                // move new selected in
                gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (i + 1) + ') .contentWrapper', speed2, { x: '-20vw', opacity: 0 }, { x: 0, opacity: 1, ease: Quad.easeOut });

                // gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (i + 1) + ') .contentWrapper .tag', 0.8, {x: '-20vw', opacity: 0}, {x: 0, opacity: 1, ease: Quad.easeOut} );
                // gsap.fromTo('.HomeSlider .slides .slide:nth-child(' + (i + 1) + ') .contentWrapper .logoHolder', 0.8, {x: '-20vw', opacity: 0}, {x: 0, opacity: 1, ease: Quad.easeOut} );

            }
            if (this.isMobile) {

                let moveAmount = 90 / this.data.slides.length

                gsap.to('.thumbsWrapper', { duration: 0.6, scrollTo: { y: i * moveAmount, x: i * moveAmount }, ease: Quad.easeOut });

                // if(i >= this.data.slides.length-2) {
                // gsap.to('.thumbsWrapper', { duration: 0.6, scrollTo: { y: 90, x: 90 }, ease: Quad.easeOut });

                // }
                // if( i <= 1) {
                //     gsap.to('.thumbsWrapper', { duration: 0.6, scrollTo: { y: 0, x: 0 }, ease: Quad.easeOut });

                // }
            }

            this.selected = i
        }
        if (this.data.slides[0].video == '' || this.data.slides[0].videoMob == '') {
            this.loop()
        }
    }

    @HostListener('window:blur')
    onBlur() {
        if (this.data && this.data.slides && this.data.slides[this.selected].video != '') {
            try {
                this.videoEl.toArray()[this.selected].nativeElement.pause()
            }
            catch (e) { }
        }
        else {
            clearTimeout(this.timeoutIndex);
        }

    }

    @HostListener('window:focus')
    onFocus() {
        if(this.data && this.data.slides && this.data?.slides[0].video != '') {

            if (this.data && this.data.slides && this.data?.slides[this.selected].video != '') {
                try {
                    if (this.bgVideoService.isPlaying) {
    
                        this.videoEl.toArray()[this.selected].nativeElement.play()
                    }
                }
                catch (e) { }
            }
            else {
                clearTimeout(this.timeoutIndex)
                if (this.bgVideoService.isPlaying) {
                    this.timeoutIndex = setTimeout(() => {
                        this.next()
                    }, 6000);
                }
            }
        }
    }

    onVideoEnded(e) {
        console.log('Video ended')
        this.next()
    }

    next() {
        if (this.selected < this.data.slides.length - 1) {
            this.onSelect(this.selected + 1)
        }
        else {
            this.onSelect(0)
        }
    }

    prev() {
        if (this.selected == 0) {
            this.onSelect(this.data.slides.length - 1)
        }
        else {
            this.onSelect(this.selected - 1)
        }
    }

    loop() {
        return
        clearTimeout(this.timeoutIndex);

        this.timeoutIndex = setTimeout(() => {
            this.next()

        }, 5000);
    }

    onSwipeLeft(e) {
        this.next()
    }

    onSwipeRight(e) {
        this.prev()
    }

    onOpenSizzleOverlay(path: string) {
        this.pageDataService.openOverlay(path)
    }
}
